var _path, _circle, _path2, _rect, _rect2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.62988 31.1331C5.62988 29.8393 5.90291 28.5582 6.43338 27.363C6.96384 26.1677 7.74136 25.0816 8.72153 24.1668C9.70171 23.252 10.8653 22.5263 12.146 22.0312C13.4267 21.5361 14.7993 21.2813 16.1854 21.2812C17.5716 21.2812 18.9442 21.5361 20.2249 22.0312C21.5055 22.5263 22.6692 23.252 23.6493 24.1668C24.6295 25.0816 25.407 26.1677 25.9375 27.363C26.468 28.5582 26.741 29.8393 26.741 31.1331",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.1859,
    cy: 14.9486,
    r: 6.33333,
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31836 11.4298C9.54675 8.54651 12.6067 6.50391 16.1871 6.50391C19.7676 6.50391 22.8275 8.54651 24.0559 11.4298",
    stroke: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.5186,
    y: 11.4297,
    width: 2.81481,
    height: 4.92593,
    rx: 1.40741,
    stroke: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.03711,
    y: 11.4297,
    width: 2.81481,
    height: 4.92593,
    rx: 1.40741,
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8887 18.4668H22.5184C23.2957 18.4668 23.9258 17.8367 23.9258 17.0594V16.3557",
    stroke: "white",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9073 12.1328C28.547 12.1328 27.4443 13.3838 27.4443 14.6349C27.4443 15.8859 28.3679 16.5114 28.3679 16.5114L28.0601 17.7624C28.0601 17.7624 32.3703 17.7624 32.3703 14.6349C32.3703 13.253 31.2676 12.1328 29.9073 12.1328Z",
    stroke: "white",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCare);
export default __webpack_public_path__ + "static/media/care.36b41b7f6d916e92d530d18bfe791c96.svg";
export { ForwardRef as ReactComponent };